const PactCard = require("../../entities/Cards/PactCard");
const Pacts = require("../../Constants/Pacts/Pacts");
const ByName = require("./ByName");

const classOf = ByName(Pacts);

const PactConverter = (pactName) =>
{
    const Class = classOf(pactName);
    return Class === undefined ? null : new PactCard(new Class());
}

module.exports = PactConverter;
